import PropTypes from "prop-types";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

import DomainForm from "./DomainForm";

const DomainModal = ({ open, onOpenChange, domain }) => (
  <Dialog open={open} onOpenChange={onOpenChange} disablePointerDismissal>
    <DialogContent className="tw:sm:max-w-lg">
      <DialogTitle>{domain ? "Edit" : "New"} Custom Email Domain</DialogTitle>
      <DomainForm
        domain={domain}
        onSuccess={() => onOpenChange(false)}
        onCancel={() => onOpenChange(false)}
      />
    </DialogContent>
  </Dialog>
);

DomainModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  domain: PropTypes.object,
};

export default DomainModal;
